import Vue from 'vue'

//
// ███████╗████████╗ █████╗ ████████╗███████╗
// ██╔════╝╚══██╔══╝██╔══██╗╚══██╔══╝██╔════╝
// ███████╗   ██║   ███████║   ██║   █████╗
// ╚════██║   ██║   ██╔══██║   ██║   ██╔══╝
// ███████║   ██║   ██║  ██║   ██║   ███████╗
// ╚══════╝   ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚══════╝
//
const state = {
  backups: {},
  backuptests: {},
  coreupdates: {},
  audits: {}
}

//
//  ██████╗ ███████╗████████╗████████╗███████╗██████╗ ███████╗
// ██╔════╝ ██╔════╝╚══██╔══╝╚══██╔══╝██╔════╝██╔══██╗██╔════╝
// ██║  ███╗█████╗     ██║      ██║   █████╗  ██████╔╝███████╗
// ██║   ██║██╔══╝     ██║      ██║   ██╔══╝  ██╔══██╗╚════██║
// ╚██████╔╝███████╗   ██║      ██║   ███████╗██║  ██║███████║
//  ╚═════╝ ╚══════╝   ╚═╝      ╚═╝   ╚══════╝╚═╝  ╚═╝╚══════╝
//
const getters = {
  siteBackupProgress: (state) => (siteId) => {
    return (typeof (state.backups[siteId]) !== 'undefined') ? state.backups[siteId] : null
  },
  backupTestProgress: (state) => (backupId) => {
    return (typeof (state.backuptests[backupId]) !== 'undefined') ? state.backuptests[backupId] : null
  },
  auditProgress: (state) => (auditId) => {
    return (typeof (state.audits[auditId]) !== 'undefined') ? state.audits[auditId] : null
  },
  siteCoreUpdateProgress: (state) => (siteId) => {
    return (typeof (state.coreupdates[siteId]) !== 'undefined') ? state.coreupdates[siteId] : null
  }
}

//
// ███╗   ███╗██╗   ██╗████████╗ █████╗ ████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ████╗ ████║██║   ██║╚══██╔══╝██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ██╔████╔██║██║   ██║   ██║   ███████║   ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██║╚██╔╝██║██║   ██║   ██║   ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║ ╚═╝ ██║╚██████╔╝   ██║   ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝     ╚═╝ ╚═════╝    ╚═╝   ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const mutations = {
  setBackupTestProgress (state, { backupId, progress }) {
    Vue.set(state.backuptests, backupId, progress)
  },

  resetBackupTestProgress (state, backupId) {
    Vue.set(state.backuptests, backupId, null)
  },

  setBackupProgress (state, { siteId, progress }) {
    Vue.set(state.backups, siteId, progress)
  },

  resetBackupProgress (state, siteId) {
    Vue.set(state.backups, siteId, null)
  },

  setAuditProgress (state, { auditId, progress }) {
    Vue.set(state.audits, auditId, progress)
  },

  resetAuditProgress (state, auditId) {
    Vue.set(state.audits, auditId, null)
  },

  setCoreUpdateProgress (state, { siteId, progress }) {
    Vue.set(state.coreupdates, siteId, progress)
  },

  resetCoreUpdateProgress (state, siteId) {
    Vue.set(state.coreupdates, siteId, null)
  }
}

//
//  █████╗  ██████╗████████╗██╗ ██████╗ ███╗   ██╗███████╗
// ██╔══██╗██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║██╔════╝
// ███████║██║        ██║   ██║██║   ██║██╔██╗ ██║███████╗
// ██╔══██║██║        ██║   ██║██║   ██║██║╚██╗██║╚════██║
// ██║  ██║╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║███████║
// ╚═╝  ╚═╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝╚══════╝
//
const actions = {
}

//
// ███████╗██╗  ██╗██████╗  ██████╗ ██████╗ ████████╗
// ██╔════╝╚██╗██╔╝██╔══██╗██╔═══██╗██╔══██╗╚══██╔══╝
// █████╗   ╚███╔╝ ██████╔╝██║   ██║██████╔╝   ██║
// ██╔══╝   ██╔██╗ ██╔═══╝ ██║   ██║██╔══██╗   ██║
// ███████╗██╔╝ ██╗██║     ╚██████╔╝██║  ██║   ██║
// ╚══════╝╚═╝  ╚═╝╚═╝      ╚═════╝ ╚═╝  ╚═╝   ╚═╝
//
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
